import React, { FC } from 'react';
import { PassportArrivalHistory } from '@/types';
import { timeConverter } from '@/utils/helpers';

interface ArrivalStampProps {
  arrival: PassportArrivalHistory;
  index: number;
  selected: boolean;
  onSelect: () => void;
  /** Hand-applied tilt (Concept 1); Concept 2 stacks upright stamps. */
  tilt?: boolean;
}

// Small alternating tilt so the stamps read as hand-applied ink.
const TILTS = [-6, 4, -2, 7, -5, 2];

export const ArrivalStamp: FC<ArrivalStampProps> = ({
  arrival,
  index,
  selected,
  onSelect,
  tilt = true,
}) => {
  const site = (arrival.siteName || `Site ${arrival.siteCode}`).toUpperCase();
  const visit = String(arrival.visitNumber || index + 1).padStart(2, '0');
  const id = `stamp-${arrival.arrivalId}`;

  return (
    <button
      type="button"
      className="pb-stamp"
      aria-pressed={selected}
      aria-label={`Arrival at ${arrival.siteName}, ${timeConverter(arrival.arrivedAt, 'D MMMM YYYY')}, visit ${visit}`}
      onClick={onSelect}
      style={
        tilt
          ? { transform: `rotate(${TILTS[index % TILTS.length]}deg)` }
          : undefined
      }
    >
      <svg viewBox="0 0 140 140" aria-hidden="true">
        <defs>
          <path id={`${id}-top`} d="M 24 70 A 46 46 0 0 1 116 70" />
          <path id={`${id}-bottom`} d="M 30 76 A 40 40 0 0 0 110 76" />
        </defs>
        <circle cx="70" cy="70" r="64" className="pb-stamp-ring" />
        <circle cx="70" cy="70" r="57" className="pb-stamp-ring thin" />
        <text className="pb-stamp-arc">
          <textPath href={`#${id}-top`} startOffset="50%" textAnchor="middle">
            GBA • ARRIVAL
          </textPath>
        </text>
        <line x1="14" y1="56" x2="126" y2="56" />
        <line x1="14" y1="84" x2="126" y2="84" />
        <text
          x="70"
          y="74"
          className="pb-stamp-site"
          textAnchor="middle"
          {...(site.length > 12 && {
            textLength: 104,
            lengthAdjust: 'spacingAndGlyphs',
          })}
        >
          {site}
        </text>
        <text x="70" y="99" className="pb-stamp-date" textAnchor="middle">
          {timeConverter(arrival.arrivedAt, 'DD MMM YYYY')?.toUpperCase()}
        </text>
        <text className="pb-stamp-arc">
          <textPath
            href={`#${id}-bottom`}
            startOffset="50%"
            textAnchor="middle"
          >
            {`VISIT ${visit}`}
          </textPath>
        </text>
      </svg>
    </button>
  );
};
